import { render, staticRenderFns } from "./barCharts.vue?vue&type=template&id=044a422b&scoped=true&"
import script from "./barCharts.vue?vue&type=script&lang=js&"
export * from "./barCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a422b",
  null
  
)

export default component.exports